import Grid from 'Components/Atoms/Grid/Grid';
import Title from 'Components/Atoms/Title/Title';
import EditButton from 'Components/Molecules/EditButton/EditButton';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Components/Organisms/Field/Field';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { patchEntity } from 'Store/Settings/Entities/Actions';
import { getEntityById, isEntityPatching } from 'Store/Settings/Entities/Selectors';

const ActivateModule = ({
    moduleId,
    entity, isPatching,
    ...props
}: ActivateModuleProps) => {
    const [data, setData] = useState({
        isActive: !!entity?.modules?.['contact']
    });
    const [state, setState] = useState({
        isEdit: false
    });

    const handleEdit = () => {
        if (state.isEdit) handleModuleChangeCancel();

        setState((state) => ({
            ...state,
            isEdit: !state.isEdit
        }));
    };

    const handleModuleChange = () => setData((state) => ({
        ...state,
        isActive: !state.isActive
    }));

    const handleModuleChangeCancel = () => setData((state) => ({
        ...state,
        isActive: !!entity?.modules?.['contact']
    }));

    const handleModuleSave = () => {
        props.patchEntity(entity.id, {
            modules: {
                ...entity.modules,
                contact: data.isActive
            }
        });
    }

    useEffect(() => {
        if (!isPatching) {
            setState((state) => ({
                ...state,
                isEdit: false
            }));
        }
    }, [isPatching]);

    return <>
        <Grid axis='horizontal' position='between'>
            <Title size='small' weight='semibold'>Algemene instellingen</Title>
            <EditButton
                variant='button'
                isEdit={state.isEdit}
                isLoading={isPatching}
                onChange={handleEdit}
                onSave={handleModuleSave}
            />
        </Grid>
        <div>
            <FormGroup title='Geactiveerd'>
                <Field
                    isEdit={state.isEdit}
                    value={data?.isActive}
                    onChange={handleModuleChange}
                    type={FieldType.Toggle}
                />
            </FormGroup>
        </div>
    </>
}

interface Props {
    entity_id: string
    moduleId: 'contact' | 'notes' | 'files' | 'file_generator'
}

const mapState = (state: StoreState, props: Props) => ({
    entity: getEntityById(state, props.entity_id),
    isPatching: isEntityPatching(state),
});

const mapDispatch = {
    patchEntity
}

type ActivateModuleProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ActivateModule);